import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

function Terms() {
  return (
    <>
      <div className="page-content header-clear-medium">
        <Header />
        <div className="content mt-2">
          <div className="card card-style mx-0 mb-3">
            <Link
              className="content mb-0"
              style={{ margin: "10px 10px 10px 10px" }}
            >
              <p className="mb-4">
                Welcome to <strong>AG Home Decor</strong>. By accessing or using
                our website, you agree to comply with and be bound by the
                following terms and conditions.
              </p>

              <h2 className="text-xl font-semibold mt-6 mb-2">
                1. Use of Website
              </h2>
              <p className="mb-4">
                You agree to use this website only for lawful purposes. You must
                not misuse the website or attempt to gain unauthorized access to
                any part of it.
              </p>

              <h2 className="text-xl font-semibold mt-6 mb-2">
                2. Intellectual Property
              </h2>
              <p className="mb-4">
                All content, logos, graphics, and images on this website are the
                property of AG Home Decor and are protected by copyright laws.
                You may not reproduce, distribute, or exploit any part of the
                site without permission.
              </p>

              <h2 className="text-xl font-semibold mt-6 mb-2">
                3. Product Information
              </h2>
              <p className="mb-4">
                We strive to display accurate product information, but we do not
                guarantee that all product descriptions, prices, or availability
                are error-free.
              </p>

              <h2 className="text-xl font-semibold mt-6 mb-2">
                4. Order Acceptance
              </h2>
              <p className="mb-4">
                We reserve the right to accept or decline any order. If your
                order is canceled after payment, the amount will be refunded.
              </p>

              <h2 className="text-xl font-semibold mt-6 mb-2">
                5. Limitation of Liability
              </h2>
              <p className="mb-4">
                AG Home Decor is not liable for any direct, indirect, or
                incidental damages resulting from the use of our website or
                services.
              </p>

              <h2 className="text-xl font-semibold mt-6 mb-2">
                6. Changes to Terms
              </h2>
              <p className="mb-4">
                We may update these Terms & Conditions at any time. Please
                review this page periodically for any changes.
              </p>

              <p className="text-sm text-gray-500 mt-6">
                Last updated: April 2025
              </p>
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Terms;
